module.exports = __webpack_public_path__ + "img/decor-1.9b2af637.svg";